import React from "react";
import ReactGA from "react-ga4";
import { Link } from "react-router-dom";
import { PageRoute } from "../../models/enums";
import { getImageLink } from "../../services/asset";
import styles from "./promotedSellerCard.scss";

const GA_CATEGORY = "Pozicija za prodavače - pretraga";

const PromotedSellerCard = (props: { seller: any; isMobile: boolean }) => {
  const { seller, isMobile } = props;

  if (!seller || !seller.userName) return null;

  const sellerUrl = `${PageRoute.user}/${seller.userName}`;
  const logoUrl = seller.avatarImage ? getImageLink(seller.avatarImage) : "";

  const handleCardClick = () => {
    ReactGA.event({
      category: GA_CATEGORY,
      action: "Click",
      label: "Klik na polje",
    });
  };

  const handleButtonClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    ReactGA.event({
      category: GA_CATEGORY,
      action: "Click",
      label: "Klik na button",
    });
  };

  return (
    <Link
      to={sellerUrl}
      className={isMobile ? styles.cardMobile : styles.card}
      onClick={handleCardClick}
    >
      <div className={styles.container}>
        <div
          className={styles.logoContainer}
          style={{ backgroundImage: `url(${logoUrl})` }}
        />

        <div className={styles.content}>
          <div>
            <div className={styles.name}>{seller.userName}</div>
            <div className={styles.description}>{seller.description}</div>
          </div>

          <div className={styles.buttonRow}>
            <button
              className={styles.button}
              onClick={handleButtonClick}
            >
              Svi oglasi oglašivača
            </button>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default PromotedSellerCard;



// WEBPACK FOOTER //
// ./src/components/PromotedSellerCard/PromotedSellerCard.tsx